import api from "../axios";

/**
 * 결재 문서 메타 관련 API
 * ApprovalMetaView (backend/views/meta_view.py) 대응
 */
const BASE_URL = "/approval/meta/";

/**
 * ✅ 결재문서 생성 (Docs + ApprovalMeta)
 * @param {Object} payload - { project, module, doc_type, title, meta }
 */
export const createMeta = async (payload) => {
  try {
    const res = await api.post(BASE_URL, payload,);
    return res.data;
  } catch (err) {
    console.error("[approval/meta] createMeta error:", err);
    throw err;
  }
};

/**
 * ✅ 결재문서 메타 조회 (dns 기준)
 * @param {string} dns - 문서 DNS
 */
export const getMeta = async (dns) => {
  try {
    const res = await api.get(BASE_URL, { params: { dns } });
    return res.data;
  } catch (err) {
    console.error("[approval/meta] getMeta error:", err);
    throw err;
  }
};

/**
 * ✅ 결재문서 메타 수정 (meta JSON 전체 업데이트)
 * @param {string} dns - 문서 DNS
 * @param {Object} meta - 수정할 메타데이터
 */
export const updateMeta = async (dns, meta) => {
  try {
    const res = await api.put(BASE_URL, { dns, meta });
    return res.data;
  } catch (err) {
    console.error("[approval/meta] updateMeta error:", err);
    throw err;
  }
};

/**
 * ✅ 결재문서 목록 조회 (필요 시 확장)
 * @param {string} project - 프로젝트 코드
 */
export const getAllMetaList = async (params = {}) => {
  try {
    const res = await api.get("/approval/alllist", { params });
    return res.data || [];
  } catch (err) {
    console.error("[approval/meta] getMetaList error:", err);
    throw err;
  }
};

export const getUserMetaList = async (params = {}) => {
  try {
    const res = await api.get("/approval/mylist", { params });
    return res.data || [];
  } catch (err) {
    console.error("[approval/meta] getMetaList error:", err);
    throw err;
  }
}

export default {
  createMeta,
  getMeta,
  updateMeta,
  getAllMetaList,
  getUserMetaList,
};
